import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CqDataInsightsComponent} from './components/cq-data-insights/cq-data-insights.component';


export const routes: Routes = [
    {path: 'cq-data-insights', component: CqDataInsightsComponent}
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class DataInsightsRoutingModule {}